import axios from 'axios';
import { API_URL } from '../utils/ApiLinks';

export const getPropertyViewCount = async (propertyId: number) => {
  try {
    const response = await axios.get(`${API_URL}/PropertyView/viewcount`, {
      params: { propertyId },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error en getPropertyViewCount:", error);
    handleAuthError(error);
    return undefined;
  }
};

export const trackPropertyView = async (propertyId: number) => {
  try {
    const response = await axios.post(`${API_URL}/PropertyView/trackview`, {
      propertyId
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error en trackPropertyView:", error);
    handleAuthError(error);
    return undefined;
  }
};

const handleAuthError = (error: any) => {
    if (error.response) {
      throw new Error(error.response.data.message || error.message); 
    } else {
      throw new Error(error.message || 'An unknown error occurred');
    }
  };